import { Dispatch } from 'redux';

import { ActionType } from '../action-types';
import { GetAllClientListAction } from '../actions';
import { fbnApi as API } from '../../../../../../../utils/api-handler';

/***********************************/
/*                                 */
/* GET ALL CLIENT LIST API CREATOR */
/*                                 */
/***********************************/

type GetAllClientRequestDataType = {
  userId: string;
  token: string;
  page: number;
  limit: number;
};

export const getAllClientList = ({
  userId,
  token,
  page,
  limit
}: GetAllClientRequestDataType) => {
  return async (dispatch: Dispatch<GetAllClientListAction>) => {
    dispatch({
      type: ActionType.GET_ALL_CLIENT_LIST_REQUEST
    });

    try {
      const response = await API(
        {
          data: '',
          method: 'GET',
          url: `/admin/clients/${userId}?page=${page}&perpage=${limit}`
        },
        token
      );
      dispatch({
        type: ActionType.GET_ALL_CLIENT_LIST_SUCCESS,
        payload: response
      });
    } catch (error) {
      dispatch({
        type: ActionType.GET_ALL_CLIENT_LIST_ERROR,
        payload: {
          data: [],
          statusCode: 400,
          message: 'Something went wrong. Please Try Again Later.'
        }
      });
    }
  };
};
